// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'
import scrubPathSummary from 'components/PathSummary/prepData/scrubPathSummary'
import { fetchPathSummaryById } from 'helpers/api'
import { warning } from 'react-notification-system-redux'
import { UNCAUGHT_ERROR } from 'errors'

import { updatePaths } from 'redux/modules/projectSummary'

const updatePathInProjectSummary = pathId => async (dispatch, getState) => {
  const { projectSummary } = getState()
  const storedPaths = projectSummary.get('paths')
  const pathInfo = storedPaths.find(d => d.get('pathId') === pathId)
  const pathIndex = pathInfo.get('pathIndex') - 1
  const unitType = projectSummary.get('unitType')

  try {
    const { entity } = await fetchPathSummaryById(pathId)
    const scrubbedPathSummary = scrubPathSummary(entity, pathIndex, unitType)
    const paths = storedPaths.set(pathIndex, fromJS(scrubbedPathSummary))
    dispatch(updatePaths(paths))
  } catch (err) {
    console.warn(err)
    dispatch(warning({
      autoDismiss: 3,
      message: `Error updating Path Summary within Project Summary - ${err.message || UNCAUGHT_ERROR}`,
    }))
  }
}

export default updatePathInProjectSummary
